import { Lotes_enajenar } from './../../../models/lotes_enajenar.model';
import { Component, ViewChild, TemplateRef } from "@angular/core";
import { FormControl, FormGroup } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import { MatDialog } from '@angular/material/dialog';
declare var jQuery: any;
declare var $: any;
@Component({
    selector: "page-lotes_enajenar",
    templateUrl: "./lotes_enajenar.component.html",
    styleUrls:['./lotes_enajenar.component.css'],
    providers: [FormService]
})

export class Lotes_enajenarComponent {
    @ViewChild('openModal', { static: true }) openModal:TemplateRef<any>;
      public rows = [];
      public actualRow;
      public actualRow2;
      public lotes_enajenar: Lotes_enajenar;
      public form;
      public temp_carct_loteo;
      public matcher = new FormService();
      public nombreForm;
      public hoja;
      public largo;
    constructor(private dialog: MatDialog){


        this.nombreForm = localStorage.getItem("form");
        console.log(this.nombreForm)
        this.form = new FormGroup({
            lotes_enajenar: new FormControl(''),
            num_lotes: new FormControl(''),
            sup_lotes_enajenar: new FormControl(''),
            hoja_anexa: new FormControl('')
        })
        if(!JSON.parse(localStorage.getItem("lotes_enajenar"))){
            localStorage.setItem("lotes_enajenar", JSON.stringify(this.rows));
        }else{
            this.rows = JSON.parse(localStorage.getItem("lotes_enajenar"));
            
            this.form.controls['lotes_enajenar'].setValue(this.rows[0]?this.rows[0].lotes_enajenar:'')
            this.form.controls['num_lotes'].setValue(this.rows[0]?this.rows[0].num_lotes:'')
            this.form.controls['sup_lotes_enajenar'].setValue(this.rows[0]?this.rows[0].sup_lotes_enajenar:'')
            this.form.controls['hoja_anexa'].setValue(this.rows[0]?this.rows[0].hoja_anexa:'NO')

        }
        this.lotes_enajenar = {lotes_enajenar:'',num_lotes:'',sup_lotes_enajenar:'', hoja_anexa:''};
        this.temp_carct_loteo = {lotes_enajenar:'',num_lotes:'',sup_lotes_enajenar:'', hoja_anexa: ''};  
    }


    add_lotes_enajenar(){
        
       

        this.actualRow = localStorage.getItem("lotes_enajenar");
        this.rows = JSON.parse(this.actualRow);
        console.log(this.rows.length)
        if(this.rows.length >= 44){
            this.hoja = "true"
        }
        
        this.rows = this.rows.concat({
            lotes_enajenar: this.form.value.lotes_enajenar,
            num_lotes: this.form.value.num_lotes,
            sup_lotes_enajenar: this.form.value.sup_lotes_enajenar,
            hoja_anexa: this.form.value.hoja_anexa

        })
        localStorage.setItem("lotes_enajenar", JSON.stringify(this.rows));
        this.actualRow2 = localStorage.getItem("lotes_enajenar");

    }

    get_lotes_enajenar(id){
        console.log(id)
        for(let x = 0; x < this.rows.length; x++){
            if(id == x){
               this.temp_carct_loteo.id = id;
               this.temp_carct_loteo.lotes_enajenar =  this.rows[x].lotes_enajenar;
               this.temp_carct_loteo.num_lotes =  this.rows[x].num_lotes;
               this.temp_carct_loteo.sup_lotes_enajenar =  this.rows[x].sup_lotes_enajenar;
               this.temp_carct_loteo.hoja_anexa =  this.rows[x].hoja_anexa;

               this.dialog.open(this.openModal);
            }
        }
    }

    cleanData(){
        this.temp_carct_loteo = {lotes_enajenar:'',num_lotes:'',sup_lotes_enajenar:'', hoja_anexa:''};
    }

    savelotes_enajenar(){
       var  id = this.temp_carct_loteo.id;
        console.log(this.temp_carct_loteo)
        for(let x = 0; x < this.rows.length; x++){
            if(id == x){
                this.rows.splice(x, 1);
                localStorage.setItem("lotes_enajenar", JSON.stringify(this.rows));
           
                    $("#clasif_modal").modal("hide");
                    this.actualRow = localStorage.getItem("lotes_enajenar");
                    this.rows = JSON.parse(this.actualRow);
                    this.rows = this.rows.concat({
                        num_lotes: this.temp_carct_loteo.num_lotes,
                        sup_lotes_enajenar: this.temp_carct_loteo.sup_lotes_enajenar,
                        hoja_anexa: this.temp_carct_loteo.hoja_anexa,

                    })
                    localStorage.setItem("lotes_enajenar", JSON.stringify(this.rows));
                    this.temp_carct_loteo = {lotes_enajenar:'',num_lotes:'',sup_lotes_enajenar:'',hoja_anexa:''};
                    this.dialog.closeAll();
                }
            }         
    }

    delete_lotes_enajenar(id){
        for(let x = 0; x < this.rows.length; x++){
            if(id == x){
                this.rows.splice(x, 1);
                localStorage.setItem("lotes_enajenar", JSON.stringify(this.rows));
            }
        }
    }

}